import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaBell,
  FaCalendar,
  FaCheck,
  FaWallet,
  FaLock,
} from "react-icons/fa";
import ProfileService from "../../../../services/Profile";
import { FaGem, FaRocket, FaCrown, FaStar } from "react-icons/fa6";
import { FaCoins, FaBitcoin, FaDollarSign, FaTrophy } from "react-icons/fa6";
import DiscountService from "../../../../services/Discount";

export default function Renew() {
  const navigate = useNavigate();
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [discountCode, setDiscountCode] = useState("");
  const [discountPercent, setDiscountPercent] = useState(0);
  const [discountMessage, setDiscountMessage] = useState("");
  const [discountMessage2, setDiscountMessage2] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loadingDiscountBtn, setLoadingDiscountBtn] = useState(false);
  const [discountedPrice, setDiscountedPrice] = useState(null);
  const currentPackage = selectedPackage || {
    price: 0,
    name: "Selected Package",
    savings: 0,
  };

  // Calculate invoice
  const discountAmount =
    discountedPrice !== null ? currentPackage.price - discountedPrice : 0;

  const priceAfterDiscount =
    discountedPrice !== null ? discountedPrice : currentPackage.price;

  const taxAmount = Math.round(priceAfterDiscount * 0.09);

  const finalAmount = priceAfterDiscount + taxAmount;
  // Handle discount code
  async function getDiscountPrice() {
    setLoadingDiscountBtn(true);
    try {
      const body = {
        packageId: selectedPackage?._id,
        code: discountCode,
      };
      console.log(body);
      const res = await DiscountService.getDiscountCodePrice(body);
      return res?.data?.data?.finalpackagePrice;
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingDiscountBtn(false);
    }
  }

  const handleApplyDiscount = async () => {
    if (!selectedPackage) {
      setDiscountMessage({
        text: "Please select a package first",
        type: "error",
      });
      return;
    }

    if (!discountCode.trim()) {
      setDiscountMessage({
        text: "Please enter a discount code",
        type: "error",
      });
      return;
    }

    if (selectedPackage.price <= 0) {
      setDiscountMessage({
        text: "Discount cannot be applied to this package",
        type: "error",
      });
      return;
    }

    setDiscountMessage("");

    const finalPrice = await getDiscountPrice();

    if (
      finalPrice == null ||
      !Number.isFinite(Number(finalPrice)) ||
      Number(finalPrice) < 0 ||
      Number(finalPrice) > selectedPackage.price
    ) {
      setDiscountMessage({
        text: "Invalid discount code or price",
        type: "error",
      });
      return;
    }

    const percent =
      ((selectedPackage.price - Number(finalPrice)) / selectedPackage.price) *
      100;

    setDiscountedPrice(Number(finalPrice));
    setDiscountPercent(Number(percent.toFixed(1)));

    setDiscountMessage({
      text: "Discount applied successfully",
      type: "success",
    });
  };

  // Handle payment

  const handlePayment = async () => {
    if (!selectedPackage) {
      setDiscountMessage2({
        text: "Please select a package",
        type: "error",
      });
      return;
    }

    setLoadingBtn(true);
    setDiscountMessage2("");

    const body = {
      packageId: selectedPackage._id,
      code: discountPercent > 0 ? discountCode.trim() : "",
    };

    try {
      const res = await ProfileService.SubscriptionPackage(body);

      if (res?.status === 200 && res?.data?.success !== false) {
        await getWalletBalance();

        setDiscountMessage2({
          text: "Payment completed successfully",
          type: "success",
        });
      } else {
        setDiscountMessage2({
          text: res?.data?.message || "Payment failed. Please try again.",
          type: "error",
        });
      }
    } catch (err) {
      console.error("Error during payment:", err);

      setDiscountMessage2({
        text:
          err?.response?.data?.message || "Payment failed. Please try again.",
        type: "error",
      });
    } finally {
      setLoadingBtn(false);
    }
  };

  const getPackageIcon = (pkg) => {
    const name = pkg?.name?.toLowerCase() || "";

    if (name.includes("۱ ماهه")) {
      return {
        icon: <FaCrown className="text-3xl text-white" />,
        bgColor: "bg-gradient-to-br from-blue-50 to-indigo-50",
        bgIcon: "bg-blue-600",
        bgSpan: "bg-amber-200/20",
        borderColor: "border-blue-600",
        badgeBg: "bg-green-100",
        badgeColor: "text-green-700",
        buttonColor: "bg-blue-600 hover:bg-blue-700",
        shadow: "shadow-blue-400",
      };
    }
    if (name.includes("۳ ماهه")) {
      return {
        icon: <FaGem className="text-3xl text-white" />,
        bgColor: "bg-gradient-to-br from-purple-50 to-pink-50",
        bgIcon: "bg-purple-600",
        bgSpan: "bg-blue-200/20",
        borderColor: "border-purple-300",
        badgeBg: "bg-purple-100",
        badgeColor: "text-purple-700",
        buttonColor: "bg-purple-600 hover:bg-purple-700",
        shadow: "shadow-purple-400",
      };
    }
    if (name.includes("۶ ماهه")) {
      return {
        icon: <FaStar className="text-3xl text-white" />,
        bgColor: "bg-gradient-to-br from-yellow-50 to-orange-50",
        bgIcon: "bg-gradient-to-br from-yellow-500 to-orange-500",
        bgSpan: "bg-purple-200/20",
        borderColor: "border-yellow-300",
        badgeBg: "bg-yellow-100",
        badgeColor: "text-yellow-700",
        buttonColor:
          "bg-gradient-to-r from-yellow-500 to-orange-500 hover:from-yellow-600 hover:to-orange-600",
        shadow: "shadow-yellow-400",
      };
    }
    if (name.includes("۱۲ ماهه")) {
      return {
        icon: <FaTrophy className="text-3xl text-white" />,
        bgColor: "bg-gradient-to-br from-gray-50 to-slate-100",
        bgIcon: "bg-gradient-to-br from-gray-700 to-gray-900",
        bgSpan: "bg-emerald-200/20",
        borderColor: "border-gray-300",
        badgeBg: "bg-gray-200",
        badgeColor: "text-gray-700",
        buttonColor:
          "bg-gradient-to-r from-gray-700 to-gray-900 hover:from-gray-800 hover:to-black",
        shadow: "shadow-gray-400",
      };
    }

    return {
      icon: <FaStar className="text-3xl text-white" />,
      bgColor: "bg-blue-50",
      bgIcon: "bg-indigo-500",
      bgSpan: "",
      borderColor: "border-indigo-300",
      badgeBg: "bg-blue-100",
      badgeColor: "text-blue-800",
      buttonColor: "bg-indigo-500 hover:bg-indigo-600",
      shadow: "shadow-indigo-300",
    };
  };

  const [newPackages, setNewPackages] = useState([]);
  const getAllPackages = async () => {
    const params = {
      Type: "subscription",
    };
    try {
      const res = await ProfileService.getAllPackages(params);
      setNewPackages(res?.data?.data);
      console.log("packages", res?.data?.data);
    } catch (err) {
      console.error(
        "Error fetching packages:",
        err?.message || JSON.stringify(err),
      );
    }
  };

  useEffect(() => {
    getAllPackages();
  }, []);

  const [walletBalance, setWalletBalance] = useState(0);
  const getWalletBalance = async () => {
    try {
      const res = await ProfileService.getProfile();
      console.log("wallet balance response:", res);
      setWalletBalance(res?.data?.data?.finduser?.wallet?.balance || 0);
    } catch (err) {
      console.error(
        "Error fetching wallet balance:",
        err?.message || JSON.stringify(err),
      );
    }
  };

  useEffect(() => {
    getWalletBalance();
  }, []);

  return (
    <div dir="ltr">
      <div className="bg-gray-50 min-h-screen pb-5">
        <header className="fixed top-0 left-0 right-0 shadow-sm z-50 bg-white px-5 py-4 grid grid-cols-5 border-b border-gray-100">
          <button
            onClick={() => navigate("/profile")}
            className="col-span-1 w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-gray-200 transition-all"
          >
            <FaArrowLeft className="text-gray-600" />
          </button>
          <h1 className="col-span-3 text-lg flex justify-center items-center font-bold text-gray-900">
            Renew Subscription
          </h1>
          <div className="col-span-1"></div>
        </header>

        <section className="py-6 mt-16">
          <div className="flex overflow-x-auto gap-4 px-4 snap-x snap-mandatory scrollbar-hide">
            {newPackages.map((pkg) => {
              const s = getPackageIcon(pkg);
              const isSelected = selectedPackage?._id === pkg._id;
              const ICON_MAP = {
                coins: FaCoins,
                bitcoin: FaBitcoin,
                dollar: FaDollarSign,
                crown: FaCrown,
                rocket: FaRocket,
                trophy: FaTrophy,
                gem: FaGem,
                star: FaStar,
              };
              const PackageIcon = ICON_MAP[pkg?.packageIcon] || FaCrown;

              return (
                <div
                  key={pkg._id}
                  className={`my-4 flex flex-col flex-shrink-0 w-[300px] snap-center border ${s.bgColor} ${s.borderColor} rounded-3xl p-5 transition-all ${
                    isSelected
                      ? `shadow-lg ${s.shadow} scale-[1.03]`
                      : "shadow-sm"
                  }`}
                >
                  <div className="flex items-center gap-4 mb-4">
                    <div
                      className={`w-14 h-14 shrink-0 ${s.bgIcon} rounded-2xl flex items-center justify-center`}
                    >
                      <PackageIcon className="text-2xl text-white" />
                    </div>
                    <div className="min-w-0">
                      <h3 className="text-xl font-bold text-gray-900 truncate">
                        {pkg.name}
                      </h3>
                      <p className="text-sm text-gray-600">{pkg.description}</p>
                    </div>
                  </div>

                  <div className="flex justify-end mb-4 min-h-[32px]">
                    {pkg.packageBadge && (
                      <span
                        className={`${s.badgeBg} ${s.badgeColor} text-sm font-bold px-4 py-1 rounded-full`}
                      >
                        {pkg.packageBadge}
                      </span>
                    )}
                  </div>
                  {/* <div className="bg-white rounded-2xl p-4 mb-4 space-y-3">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3 text-gray-700">
                        <FaBell className="text-orange-500" />
                        <span>Daily Alert</span>
                      </div>
                      <span className="font-bold text-gray-900 text-lg">
                        10
                      </span>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3 text-gray-700">
                        <FaCalendar className="text-blue-500" />
                        <span>Monthly Alert</span>
                      </div>
                      <span className="font-bold text-gray-900 text-lg">
                        30
                      </span>
                    </div>
                  </div> */}

                  <div className="flex items-end justify-between gap-2 mb-4">
                    <div>
                      <div className="text-sm text-gray-600">Savings</div>
                      <div className="text-sm font-bold text-green-600">
                        {pkg.savings > 0
                          ? pkg.savings.toLocaleString("en-US") + " USDT"
                          : "0 USDT"}
                      </div>
                    </div>
                    <div className="text-right">
                      <span className="text-3xl font-bold text-gray-900">
                        {pkg.price.toLocaleString("en-US")}
                      </span>
                      <span className="text-xs text-gray-600 ml-1">USDT</span>
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      setSelectedPackage(pkg);
                      setDiscountPercent(0);
                      setDiscountedPrice(null);
                      setDiscountMessage("");
                      setDiscountMessage2("");
                    }}
                    className={`mt-auto w-full ${s.buttonColor} text-white py-4 rounded-2xl font-bold text-base transition-all`}
                  >
                    Buy Subscription
                  </button>
                </div>
              );
            })}
          </div>
        </section>

        {/* Features Section */}
        <section className="px-4 py-6">
          <div className="bg-white rounded-3xl p-6 border border-gray-200">
            <h3 className="text-lg font-bold text-gray-900 mb-4">
              All packages include the following
            </h3>
            <div className="space-y-3">
              {[
                "Instant signal notifications",
                "24-hour support",
                "Advanced analytics dashboard",
                "Priority signal delivery",
              ].map((feature, idx) => (
                <div key={idx} className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center ml-3">
                    <FaCheck className="text-green-600 text-sm" />
                  </div>
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Discount Code Section */}
        <section className="px-4 py-4">
          <div className="bg-white rounded-3xl p-5 border border-gray-200">
            <label className="text-sm font-medium text-gray-700 mb-2 block">
              Have a discount code?
            </label>
            <div className="flex gap-2 mb-2">
              <input
                type="text"
                value={discountCode}
                onChange={(e) => {
                  setDiscountCode(e.target.value);
                  setDiscountPercent(0);
                  setDiscountedPrice(null);
                  setDiscountMessage("");
                }}
                placeholder="Enter discount code"
                className="flex-1 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
              <button
                disabled={loadingDiscountBtn || selectedPackage === null}
                onClick={handleApplyDiscount}
                className={`${loadingDiscountBtn && "animate-bounce"} px-6 py-3 text-white rounded-xl font-medium text-sm hover:bg-blue-700 transition-all ${loadingDiscountBtn || selectedPackage == null ? "bg-blue-400" : "bg-blue-600"}`}
              >
                {loadingDiscountBtn ? "..." : "Apply"}
              </button>
            </div>
            {discountMessage && (
              <div
                className={`text-sm font-medium ${discountMessage.type === "success" ? "text-green-600" : "text-red-600"}`}
              >
                {discountMessage.text}
              </div>
            )}
          </div>
        </section>

        {/* Invoice Section */}
        <section className="px-4 py-4">
          <div className="bg-white rounded-3xl p-6 border border-gray-200">
            <h3 className="text-lg font-bold text-gray-900 mb-5 pb-3 border-b border-gray-100">
              Payment Invoice
            </h3>

            <div className="space-y-4 mb-5">
              <div className="flex items-center justify-between">
                <span className="text-gray-600">Selected Package</span>
                <span className="font-bold text-gray-900">
                  {selectedPackage?.name}
                </span>
              </div>

              <div className="flex items-center justify-between">
                <span className="text-gray-600">Package Price</span>
                <span className="font-bold text-gray-900">
                  {selectedPackage?.price.toLocaleString("en-US")} USDT
                </span>
              </div>

              {discountPercent > 0 && (
                <div className="flex items-center justify-between text-green-600">
                  <span>Discount ({discountPercent}%)</span>
                  <span className="font-bold">
                    -{discountAmount.toLocaleString("en-US")} USDT
                  </span>
                </div>
              )}

              <div className="flex items-center justify-between">
                <span className="text-gray-600">Tax (9%)</span>
                <span className="font-medium text-gray-900">
                  {taxAmount.toLocaleString("en-US")} USDT
                </span>
              </div>
            </div>

            <div className="border-t border-gray-200 pt-4 mb-5">
              <div className="flex items-center justify-between">
                <span className="text-lg font-bold text-gray-900">
                  Final Amount
                </span>
                <span className="text-2xl font-bold text-blue-600">
                  {finalAmount.toLocaleString("en-US")} USDT
                </span>
              </div>
            </div>

            <div className="bg-blue-50 rounded-2xl p-4 mb-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <FaWallet className="text-blue-600 text-xl ml-3" />
                <div>
                  <div className="text-xs text-gray-600 mb-1">
                    Wallet Balance
                  </div>
                  <div className="font-bold text-gray-900">
                    {walletBalance.toLocaleString("en-US")} USDT
                  </div>
                </div>
              </div>
              <div
                className={`text-xs font-medium ${walletBalance < finalAmount || walletBalance === 0 ? "text-red-600" : "text-green-600"}`}
              >
                {walletBalance < finalAmount || walletBalance === 0
                  ? "Insufficient balance"
                  : "Wallet balance"}
              </div>
            </div>

            {discountMessage2 && (
              <div
                className={`text-sm font-medium mb-4 ${discountMessage2.type === "success" ? "text-green-600" : "text-red-600"}`}
              >
                {discountMessage2.text}
              </div>
            )}

            <button
              onClick={handlePayment}
              disabled={
                !selectedPackage || walletBalance < finalAmount || loadingBtn
              }
              className={`w-full text-white py-4 rounded-2xl font-bold text-base transition-all shadow-lg flex items-center justify-center gap-2 ${
                loadingBtn
                  ? "bg-blue-400 cursor-not-allowed"
                  : "bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700"
              } ${
                !selectedPackage || walletBalance < finalAmount
                  ? "opacity-50 cursor-not-allowed"
                  : ""
              }`}
            >
              <FaLock />
              {loadingBtn ? "Please wait..." : "Pay from Wallet"}
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
